import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useAccount } from 'wagmi';

export default function SessionHandler() {

  const [cookies, setCookie] = useCookies();

  const { address } = useAccount();
  let isWalletConnected = (address !== null && typeof (address) !== 'undefined');

  function sessionValid() {
    console.log("isWalletConnected", isWalletConnected);
    console.log("cookies.userType", cookies.userType);
    console.log("cookies.sessionUser", cookies.sessionUser);
    console.log("cookies.sessionUserType", cookies.sessionUserType);
    console.log("cookies.sessionSignature", cookies.sessionSignature);
    console.log("cookies.sessionExpiringAt", cookies.sessionExpiringAt);
    return (isWalletConnected && cookies.sessionUserType !== undefined && cookies.sessionUser !== undefined && cookies.sessionSignature !== undefined && cookies.sessionExpiringAt !== undefined && cookies.sessionExpiringAt > Date.now());
  }

  function logout() {
    console.log("logout");

    let expiresAt = new Date(0);
    setCookie('sessionUser', '', { path: '/', expires: expiresAt });
    setCookie('sessionExpiringAt', '', { path: '/', expires: expiresAt });
    setCookie('sessionSignature', '', { path: '/', expires: expiresAt });
    setCookie('sessionUserType', '', { path: '/', expires: expiresAt });

  }

  useEffect(() => {
    console.log("cookies", cookies);
    if (!sessionValid() || cookies.sessionUser !== address) {
      logout();
    }
  }, [address, cookies]);


  return (
    sessionValid() ? (
      null
    ) : (
      <Navigate replace to="/login" />
    )
  );
}